export default "__VITE_ASSET__4822c0cc__"